import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-arrow_up",
  "use": "rt-base-arrow_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 1024 1024\" id=\"rt-base-arrow_up\">\r\n<path d=\"M890.5,755.3L537.9,269.2c-12.8-17.6-39-17.6-51.7,0L133.5,755.3c-3.8,5.3-0.1,12.7,6.5,12.7h75c5.1,0,9.9-2.5,12.9-6.6\r\n\tL512,369.8l284.1,391.6c3,4.1,7.8,6.6,12.9,6.6h75C890.5,768,894.3,760.6,890.5,755.3z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/arrow_up.svg
// module id = 1227
// module chunks = 116